/* eslint-disable complexity */
/* eslint-disable max-lines-per-function */
import React from "react";
import SummaryBar from "../SummaryBar";
import styles from "./AdSummary.scss";
import { AdPrice } from "./AdPrice";
import FavoriteButtonWhite from "../../../containers/FavoriteButtonWhite";
import DateAndLocation from "./DateAndLocation";
import { AdYouTube } from "../../AdCard/AdYouTube";
import { parsePriceString } from "../../../services";


const AdSummary = ({
  ad,
  className,
  hasFavorite,
  adLists,
  isMobile,
  category,
  flag,
  featuredLabel,
  isPersonalCar
}) => {
  const adPriceStyle = isMobile ? styles.adPriceMobile : styles.adPriceDesktop;

  const renderFavoriteButton = () => {
    if (!hasFavorite) {
      return null;
    }

    return (
      <span className={styles.bottomButtonContainer}>
        <FavoriteButtonWhite
          adLists={adLists}
          ad={ad}
          className={styles.bottomButton}
          category={category}
          flag={flag}
        />
      </span>
    );
  };

  return (
    <React.Fragment>
      {!isMobile ? <DateAndLocation ad={ad} /> : null}
      <div className={`${styles.container}  ${className}`}>
        <div className={styles.infoRow}>
          <div
            className={isMobile ? styles.titleMobile : styles.title}
            title={ad.title}
          >
            {ad.title}
          </div>
        </div>

        <SummaryBar summary={ad.summary} />
      </div>

      {/* Rendered for every personal-car ad so all cards in the carousel keep
          the same height even when only some ads carry the highlight label —
          the empty span is hidden via scss. Non-car categories never render
          the pill and stay at their natural height. */}
      {isPersonalCar && (
        <span className={styles.featuredPropertyInline}>{featuredLabel || ""}</span>
      )}

      <div className={styles.bottomPart}>
        <AdPrice
          price={ad.price}
          priceTo={ad.priceTo}
          previousPrice={ad.previousPrice}
          className={adPriceStyle}
          rentPriceType={ad.rentPriceType}
          priceType={ad.priceType}

        />

        {ad.videoUrl && !adLists.search && (
          <AdYouTube isSearchPage={adLists.search} />
        )}
      </div>
      {ad.priceM2 && (
        <div className={styles.priceM2}>
          {parsePriceString(Math.round(ad.priceM2))}/m<sup>2</sup>
        </div>
      )}

    </React.Fragment>
  );
};

AdSummary.defaultProps = {
  className: "",
  hasFavorite: true,
  adLists: {},
  isMobile: false,
  featuredLabel: null,
  isPersonalCar: false
};

export default AdSummary;



// WEBPACK FOOTER //
// ./src/components/SimilarAdCard/AdSummary/AdSummary.tsx